import { GraphDto } from "@custom-types/graphs"
import { atom } from "jotai"

export const graphAtom = atom<GraphDto | null>(null)
export const maxLagAtom = atom<number>(0)

if (process.env.NODE_ENV !== "production") {
  graphAtom.debugLabel = "RunGroupForm/graphAtom"
  maxLagAtom.debugLabel = "RunGroupForm/maxLagAtom"
}
